import { fetcher, fetcherConfig } from '../../../lib/api-fetcher';
import { createResourceClient } from '@repo/api-client';
import { z } from 'zod';
import type {
  AgentListItem,
  AgentDetail,
  CreateAgentRequest,
  UpdateAgentRequest,
  SuspendAgentRequest,
  AssignTerritoryRequest,
  TerritoryAssignment,
  PerformanceSummary,
} from '../types';

const schemas = {
  listItem: z.any() as z.ZodType<AgentListItem>,
  detail: z.any() as z.ZodType<AgentDetail>,
  create: z.any() as z.ZodType<CreateAgentRequest>,
  update: z.any() as z.ZodType<UpdateAgentRequest>,
};


// The base client for standard CRUD operations
const baseAgentClient = createResourceClient<
  AgentListItem,
  AgentDetail,
  CreateAgentRequest,
  UpdateAgentRequest
>(fetcherConfig, {
  path: '/staff/v1/agents',
  schemas,
});

// Custom fetcher for additional operations

export const agentClient = {
  ...baseAgentClient,
  
  suspend: (id: string, body: SuspendAgentRequest) => 
    fetcher.post<{ data: AgentDetail }>(`/staff/v1/agents/${id}/suspend`, body),
    
  terminate: (id: string) => 
    fetcher.post<{ data: AgentDetail }>(`/staff/v1/agents/${id}/terminate`, {}),
    
  reinstate: (id: string) => 
    fetcher.post<{ data: AgentDetail }>(`/staff/v1/agents/${id}/reinstate`, {}),
    
  getTerritory: (id: string) =>
    fetcher.get<{ data: TerritoryAssignment[] }>(`/staff/v1/agents/${id}/territory`),
    
  assignTerritory: (id: string, body: AssignTerritoryRequest) =>
    fetcher.post<{ data: TerritoryAssignment[] }>(`/staff/v1/agents/${id}/territory`, body),
    
  removeTerritory: (id: string, orgUnitId: string) =>
    fetcher.delete(`/staff/v1/agents/${id}/territory/${orgUnitId}`),
    
  getPerformance: (id: string) =>
    fetcher.get<{ data: PerformanceSummary[]; meta: any }>(`/staff/v1/agents/${id}/performance`),
};
